module.exports = __webpack_public_path__ + "img/h-3.e598a79a.jpg";